import { useState } from 'react';
import { Button } from '@cmsgov/ds-healthcare-gov';
import ExpenseFields from '../ExpenseFields';
import { formatCurrency } from '../../../utilities/currency';
import { frequencyMappedToDisplay, FrequencyType } from '../../../common/enums/FrequencyTypes';
import { expenseLabel, ExpenseType } from '../../../common/enums/ExpenseTypes';
import { useTranslation } from 'react-i18next';
import { Expense } from '../IncomeCalculator';

type Props = {
  // key: string,
  id: string;
  editing: boolean;
  expenseType: ExpenseType;
  amount: string;
  expenseFrequency: FrequencyType;
  calculatedTotal: number;
  onUpdateExpenseEntry: (expenseRecord: Expense, id: string) => void;
  onRemoveExpense: (id: string) => void;
};

export const getExpenseSummaryString = (props: any) => {
  const { expenseType, amount, expenseFrequency, t } = props;
  return t('expenseSummaryRow', {
    expenseSource: t(expenseLabel[expenseType]),
    amount: formatCurrency(parseFloat(amount)),
    frequency: t(frequencyMappedToDisplay[expenseFrequency]).toLowerCase(),
  });
};

const ExpenseRow = (props: Props) => {
  const [editing, setEditing] = useState<boolean>(props.editing);
  const { t } = useTranslation();

  const ariaLabel = (buttonLabel: string) => {
    const expenseKey = expenseLabel[props.expenseType];
    // Using type assertion for dynamic translation keys - this is the recommended approach
    // for react-i18next v12 when using dynamic enum values
    return `${(t as any)(buttonLabel)} ${(t as any)(expenseKey)}`;
  };

  const handleDoneClick = (expenseRecord: Expense) => {
    props.onUpdateExpenseEntry(expenseRecord, props.id);
    setEditing(false);
  };

  const handleCancelClick = () => {
    setEditing(false);
  };

  let expenseSummary = getExpenseSummaryString({ ...props, t });
  if (expenseSummary) {
    const index = expenseSummary.indexOf(':') + 1;

    const header = expenseSummary.substring(0, index);
    const info = expenseSummary.substring(index);

    expenseSummary = `<strong>${header}</strong>${info}`;
  }

  return (
    <div className="ds-l-col--12 ds-u-border-bottom--2">
      {editing ? (
        <ExpenseFields
          expenseType={props.expenseType}
          amount={props.amount}
          expenseFrequency={props.expenseFrequency}
          onCancelAddExpense={handleCancelClick}
          onDoneClick={handleDoneClick}
        />
      ) : (
        <>
          <div className="ds-l-col--12 ds-u-padding--0">
            <div className="ds-u-justify-content--between ds-u-display--flex ds-u-margin-y--1">
              <div dangerouslySetInnerHTML={{ __html: expenseSummary }} />
              <div>{formatCurrency(props.calculatedTotal)}</div>
            </div>
          </div>
          <div className="ds-l-col--12 ds-u-margin-bottom--3 ds-u-padding--0">
            <Button
              className="ds-u-margin-right--1"
              size="small"
              onClick={() => setEditing(true)}
              aria-label={ariaLabel('edit')}
            >
              {t('edit')}
            </Button>
            <Button size="small" onClick={() => props.onRemoveExpense(props.id)} aria-label={ariaLabel('remove')}>
              {t('remove')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ExpenseRow;
